import React from "react";

import { Link } from "react-router-dom";

export default function Terms() {
  return (
    <div className="min-h-screen mesh-bg">
      <div className="max-w-4xl mx-auto px-4 py-16">
        <Link to="/" className="text-sm text-emerald-600">
          ← Back to home
        </Link>

        <div className="card-soft p-8 mt-6">
          <h1 className="font-display text-4xl font-bold">
            Terms & Conditions
          </h1>

          <p className="mt-2 text-sm text-slate-500">Last updated: May 2026</p>

          <div className="prose prose-slate dark:prose-invert max-w-none mt-8">
            <section className="space-y-4">
              <h2 className="text-2xl font-bold">1. Acceptance of Terms</h2>

              <p>
                By accessing or using AccessWealth, including our website,
                mobile applications, APIs, and related services, you agree to
                comply with and be bound by these Terms & Conditions.
              </p>

              <p>
                If you do not agree with these terms, you should not use the
                platform.
              </p>
            </section>

            <section className="mt-10 space-y-4">
              <h2 className="text-2xl font-bold">2. Description of Service</h2>

              <p>
                AccessWealth provides digital tools for wealth tracking,
                financial organization, nominee management, inheritance
                planning, document vault storage, family linking, and related
                financial management services.
              </p>

              <p>
                AccessWealth is a technology platform only and does not provide
                legal, tax, accounting, fiduciary, investment, or financial
                advisory services.
              </p>
            </section>

            <section className="mt-10 space-y-4">
              <h2 className="text-2xl font-bold">3. User Responsibilities</h2>

              <p>
                Users are solely responsible for all information uploaded,
                entered, shared, linked, or stored within the platform.
              </p>

              <p>
                You agree to provide accurate, lawful, and authorized
                information at all times.
              </p>

              <p>
                You are responsible for maintaining the confidentiality of your
                account credentials and restricting access to your devices and
                authentication methods.
              </p>
            </section>

            <section className="mt-10 space-y-4">
              <h2 className="text-2xl font-bold">
                4. Family, Nominee & Inheritance Disclaimer
              </h2>

              <p>
                AccessWealth does not independently verify family relationships,
                inheritance rights, nominee claims, ownership claims, wills,
                succession documents, or legal entitlements.
              </p>

              <p>
                Family linking, nominee allocations, inheritance distributions,
                and related records are based entirely on information provided
                by users.
              </p>

              <p>
                Users are fully responsible for ensuring that all nominee and
                family information entered into the platform is accurate,
                lawful, and authorized.
              </p>
            </section>

            <section className="mt-10 space-y-4">
              <h2 className="text-2xl font-bold">
                5. No Legal or Financial Guarantee
              </h2>

              <p>
                Information stored within AccessWealth does not constitute a
                legally binding will, trust, inheritance instruction, legal
                agreement, investment advice, or financial guarantee unless
                separately validated under applicable law.
              </p>

              <p>
                Users should consult qualified legal, tax, and financial
                professionals before making important financial or inheritance
                decisions.
              </p>
            </section>

            <section className="mt-10 space-y-4">
              <h2 className="text-2xl font-bold">6. Account Security</h2>

              <p>
                Users are responsible for protecting their passwords, email
                accounts, devices, authentication credentials, and account
                access methods.
              </p>

              <p>
                AccessWealth is not responsible for unauthorized access
                resulting from compromised credentials, insecure devices,
                phishing attacks, or user negligence.
              </p>
            </section>

            <section className="mt-10 space-y-4">
              <h2 className="text-2xl font-bold">
                7. Vault & Uploaded Documents
              </h2>

              <p>
                Users may upload documents and files to the secure vault
                feature. Users retain ownership of uploaded content and are
                solely responsible for the legality, authenticity, and accuracy
                of uploaded materials.
              </p>

              <p>
                AccessWealth reserves the right to remove content that violates
                applicable laws, security policies, or platform integrity
                requirements.
              </p>
            </section>

            <section className="mt-10 space-y-4">
              <h2 className="text-2xl font-bold">8. Prohibited Activities</h2>

              <p>Users may not use AccessWealth for:</p>

              <ul className="space-y-2">
                <li>Fraudulent or illegal activity</li>
                <li>Identity theft or impersonation</li>
                <li>Unauthorized access attempts</li>
                <li>Uploading malicious software or harmful content</li>
                <li>Abuse of family linking or nominee systems</li>
                <li>Violating applicable financial or privacy laws</li>
              </ul>
            </section>

            <section className="mt-10 space-y-4">
              <h2 className="text-2xl font-bold">9. Limitation of Liability</h2>

              <p>
                To the maximum extent permitted by law, AccessWealth shall not
                be liable for:
              </p>

              <ul className="space-y-2">
                <li>Incorrect nominee or inheritance information</li>
                <li>Family linking disputes</li>
                <li>User-entered financial inaccuracies</li>
                <li>Unauthorized access caused by compromised credentials</li>
                <li>Loss of profits, assets, or financial opportunities</li>
                <li>Third-party email or infrastructure failures</li>
                <li>Service interruptions or downtime</li>
                <li>Legal disputes arising between users or family members</li>
              </ul>
            </section>

            <section className="mt-10 space-y-4">
              <h2 className="text-2xl font-bold">10. Service Availability</h2>

              <p>
                Features, services, pricing, and functionality may change, be
                updated, restricted, suspended, or removed without prior notice.
              </p>

              <p>
                We do not guarantee uninterrupted or error-free service
                availability at all times.
              </p>
            </section>

            <section className="mt-10 space-y-4">
              <h2 className="text-2xl font-bold">
                11. Account Suspension & Termination
              </h2>

              <p>
                AccessWealth reserves the right to suspend, restrict, or
                terminate accounts involved in abuse, fraud, suspicious
                activity, security threats, or violations of these Terms.
              </p>
            </section>

            <section className="mt-10 space-y-4">
              <h2 className="text-2xl font-bold">12. Intellectual Property</h2>

              <p>
                All platform branding, software, designs, interfaces, and
                related intellectual property belong to AccessWealth unless
                otherwise stated.
              </p>

              <p>
                Users may not copy, distribute, reverse engineer, or
                commercially exploit platform content without written
                permission.
              </p>
            </section>

            <section className="mt-10 space-y-4">
              <h2 className="text-2xl font-bold">13. Changes to Terms</h2>

              <p>
                We may update these Terms & Conditions periodically. Continued
                use of AccessWealth after updates constitutes acceptance of the
                revised terms.
              </p>
            </section>

            <section className="mt-10 space-y-4">
              <h2 className="text-2xl font-bold">14. Governing Law</h2>

              <p>
                These Terms shall be governed and interpreted in accordance with
                applicable laws and regulations of India.
              </p>
            </section>

            <section className="mt-10 space-y-4">
              <h2 className="text-2xl font-bold">15. Contact</h2>

              <p>For legal inquiries, account concerns, or support, contact:</p>

              <p className="font-semibold text-emerald-600">
                info@accesswealth.in
              </p>
            </section>
          </div>
        </div>
      </div>
    </div>
  );
}
